import { ref } from 'vue';
import wootConstants from 'dashboard/constants/globals';

const ASSIGNEE_TYPES = Object.values(wootConstants.ASSIGNEE_TYPE);

// One value for the whole dashboard: the conversation list filters by it and the sidebar marks its item as the
// current one. Opening a conversation does not touch it, so the list stays where it was.
const activeAssignee = ref(wootConstants.ASSIGNEE_TYPE.ME);

export const isAssigneeType = value => ASSIGNEE_TYPES.includes(value);

export function useAssigneeTab() {
  const setAssignee = value => {
    if (isAssigneeType(value)) activeAssignee.value = value;
  };

  return { activeAssignee, setAssignee };
}
